import { inject, Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FileModel } from '@seahorse/domain';
import {
  BaseFilesCardService,
  FileDropModel,
  FileImportDialogComponent,
  FileListCardComponent,
} from '@seahorse/temp';
import * as _ from 'underscore';

@Injectable({
  providedIn: 'root',
})
export class FileListCardService extends BaseFilesCardService {
  private _modal = inject(NgbModal);

  override filesAdd(
    component: FileListCardComponent,
    fileDropped?: FileDropModel
  ) {
    const size = this.env.useFileUploadWizard ? 'xl' : 'md';

    const m: NgbModalRef = this._modal.open(FileImportDialogComponent, {
      backdrop: 'static',
      size: size,
    });

    if (fileDropped) {
      m.componentInstance.objectMappingKey = fileDropped.objectType;
      m.componentInstance.objectId = fileDropped.objectId;
      m.componentInstance.object = fileDropped.object;
      m.componentInstance.filesDropped = fileDropped.files;
      m.componentInstance.objectFieldDefinitions =
        component.objectFieldDefinitions;
      m.componentInstance.inbox = true;
    } else {
      m.componentInstance.objectMappingKey = component.objectType;
      m.componentInstance.objectId = component.objectId;
      m.componentInstance.object = component.object;
      m.componentInstance.objectFieldDefinitions =
        component.objectFieldDefinitions;
      m.componentInstance.inbox = true;
    }

    m.componentInstance.confirm.subscribe((o: { files: FileModel[] }) => {
      o.files.map((file) => {
        file.isInbox = true;
      });

      if (component.files && component.files.length) {
        component.files = _.sortBy(component.files.concat(o.files), [
          'isInbox',
          'name',
        ]);
      } else {
        component.files = _.sortBy(o.files, ['name', 'isInbox']);
      }
    });
  }
}
